/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $TeamListWithoutLeagues = {
    properties: {
        officialName: {
            type: 'string',
            isRequired: true,
        },
        id: {
            type: 'number',
            isRequired: true,
        },
        name: {
            type: 'Translation',
            isRequired: true,
        },
        internalName: {
            type: 'string',
            isRequired: true,
        },
        emblem: {
            type: 'Image',
            isRequired: true,
        },
        primaryColor: {
            type: 'string',
            isRequired: true,
        },
        secondaryColor: {
            type: 'string',
            isRequired: true,
        },
    },
} as const;
